class removeFields {
    // This executes when the function is instantiated.
    constructor() {
        this.iterateLinks()
    }

    iterateLinks() {
        // Use event delegation to ensure any fields added after the page loads are captured.
        document.addEventListener('click', e => {
            // Check if the clicked element or any of its parents has the 'remove-fields' class
            let link = e.target.closest('.remove-fields')
            if (link) {
                this.handleClick(link, e)
            }
        })
    }

    handleClick(link, e) {
        // Stop the function from executing if a link or event were not passed into the function.
        if (!link || !e) return
        // Prevent the browser from following the URL.
        e.preventDefault()
        // Find the closest nested field wrapper (card with margin classes or bs-callout)
        let wrapper = link.closest('.card.mx-1, .card.my-1, .card.my-2, .card.my-3, .bs-callout')
        if (!wrapper) {
            // Fallback to finding parent for table rows
            wrapper = link.parentNode.nodeName === 'TD' ? link.parentNode.parentNode : link.parentNode
        }
        // Find the _destroy hidden field specifically
        let deleteField = wrapper ? wrapper.querySelector('input[name*="[_destroy]"]') : null
        // If there is a delete field, update the value to `1` and hide the corresponding nested fields.
        if (deleteField) {
            deleteField.value = 1
            wrapper.style.display = 'none'
        }
    }
}

// Wait for turbo to load, otherwise `document.querySelectorAll()` won't work
window.addEventListener('turbo:load', () => new removeFields())
// Also support turbolinks for backwards compatibility
window.addEventListener('turbolinks:load', () => new removeFields())